import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatCurrency } from '@angular/common';

@Pipe({
  name: 'terraCurrency'
})
export class TerraCurrencyNoSymbolPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private _locale: string) { }

  transform(value: any, locale?: string): string | null {
    if (isEmpty(value)) {
      return '0';
    }

    locale = locale || this._locale;

    try {
      const num = strToNumber(value);

      // digits info: allow only 0 or 2 decimal points:
      let digitsInfo = '1.0-0';
      if (Math.floor(num) !== num) {
        digitsInfo = '1.2-2';
      }
      return formatCurrency(num, locale, '', '', digitsInfo);
    } catch (error) {
      throw new Error(`InvalidPipeArgument: for pipe 'CurrencyPipe'`);
    }
  }
}

function isEmpty(value: any): boolean {
  return !value;
}

/**
 * Transforms a string into a number (if needed).
 */
function strToNumber(value: number | string): number {
  if (typeof value === 'string') {
    value = value.replace(/,/g, '');
  }
  // Convert strings to numbers
  if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
    return Number(value);
  }
  if (typeof value !== 'number') {
    throw new Error(`${value} is not a number`);
  }
  return value;
}
